export default __webpack_public_path__ + "static/media/cat-04.75d35685.jpg";